import { render, staticRenderFns } from "./AdminArchive.vue?vue&type=template&id=15943697&scoped=true"
import script from "./AdminArchive.vue?vue&type=script&lang=js"
export * from "./AdminArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15943697",
  null
  
)

export default component.exports